import './index';
import { ReactElement } from 'react';
import { InfoView } from '@client//common/components/InfoView';
import { useTranslate } from '@client/i18n/hooks';
import defaultImage from './assets/noresults.svg';
import { Props } from './';

export const NoResults = ({ className, iconType, image = defaultImage }: Props): ReactElement => {
  const t = useTranslate();

  return (
    <InfoView
      className={className}
      image={image}
      title={t('No results found.')}
      message={t('Your search has returned no results.')}
      iconType={iconType}
    />
  );
};
